import { ReactNode } from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import styled from 'styled-components';
import classNames from 'classnames';

interface DroppableZoneProps {
  id: string;
  children: ReactNode;
  items: any[];
  disabled?: boolean;
  className?: string;
}

const StyledDropZone = styled.div`
  min-height: 200px;
  width: 100%;
  border-radius: 8px;

  &.is-over {
    background-color: rgba(33, 150, 243, 0.08);
    outline: 2px dashed #2196f3;
    outline-offset: 2px;
  }
`;

export const DroppableZone = ({ id, children, items, disabled, className }: DroppableZoneProps) => {
  const { setNodeRef, isOver } = useDroppable({ id });

  return (
    <StyledDropZone ref={setNodeRef} className={classNames(className, { 'is-over': isOver && !disabled })}>
      <SortableContext items={items} strategy={verticalListSortingStrategy}>
        {children}
      </SortableContext>
    </StyledDropZone>
  );
};
